import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-brand dark:bg-navy-900 text-stone-300 dark:text-stone-400 py-16 transition-colors duration-300 border-t border-transparent dark:border-navy-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo_vidento.png" alt="Vidento Logo" className="h-16 w-16 object-contain rounded-full" />
              <span className="text-2xl font-serif font-bold text-white">Vidento Verlag</span>
            </div>
            <p className="text-stone-400 dark:text-stone-500 max-w-sm leading-relaxed mb-6">
              Literatur, die bleibt. Ihr Verlag für bewahrte Klassiker,
              demografisches Wissen und anspruchsvolle Kinder- und Jugendliteratur.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold text-white mb-6">Navigation</h3>
            <ul className="space-y-3 text-sm">
              <li><button onClick={() => scrollToSection('verlag')} className="hover:text-amber-400 transition-colors">Über uns</button></li>
              <li><button onClick={() => scrollToSection('abteilungen')} className="hover:text-amber-400 transition-colors">Abteilungen</button></li>
              <li><Link to="/autoren" className="hover:text-amber-400 transition-colors">Autoren</Link></li>
              <li><Link to="/kontakt" className="hover:text-amber-400 transition-colors">Kontakt</Link></li>
              <li><Link to="/impressum" className="hover:text-amber-400 transition-colors">Impressum</Link></li>
              <li><Link to="/dsgvo" className="hover:text-amber-400 transition-colors">Datenschutz / DSGVO</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-white mb-6">Kontakt</h3>
            <address className="not-italic text-sm space-y-2 text-stone-400 dark:text-stone-500">
              <p className="font-bold text-stone-200">Föreningen Vidento</p>
              <p>Örträsk 48</p>
              <p>935 93 Norsjö (Schweden)</p>
              <p className="pt-2">Email: post@vidento.eu</p>
            </address>
          </div>
        </div>

        <div className="border-t border-stone-800 mt-12 pt-8 text-sm text-center text-stone-500">
          &copy; {new Date().getFullYear()} Vidento Verlag. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
